import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";

import Background from "../../../../Assets/Images/background.jpg";
import CustomerSignUp from "./CustomerSignUp/CustomerSignUp";
import AuthorSignUp from "./AuthorSignUp/AuthorSignUp";
import LoginSignUpTab from "../LoginSignUpTab";
import { useStyles } from "./SignUp.css";

class SignUp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: this.props.match.params.type,
    };
  }

  handleCurrentPage = (e, newValue) => {
    this.setState({
      currentPage: newValue,
    });
  };

  showSignUpPage = (page) => {
    switch (page) {
      case "Customer":
        return <CustomerSignUp />;

      case "Author":
        return <AuthorSignUp />;

      default:
        break;
    }
  };

  render() {
    const { classes } = this.props;
    return (
      <div
        className={classes.signRoot}
        style={{
          backgroundImage: `url(${Background})`,
        }}
      >
        <LoginSignUpTab
          currentPage={this.state.currentPage}
          handleCurrentPage={this.handleCurrentPage}
        />
        <br />
        {/* <div style={{paddingLeft:80,paddingRight:80}}> */}
        {this.showSignUpPage(this.state.currentPage)}
        {/* </div> */}
      </div>
    );
  }
}

export default withStyles(useStyles)(withRouter(SignUp));
